webpackJsonp([215163933632717],{

/***/ 563:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(7);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _ThemeNavFooter = __webpack_require__(104);
	
	var _ThemeNavFooter2 = _interopRequireDefault(_ThemeNavFooter);
	
	var _ShareExhibit = __webpack_require__(85);
	
	var _ShareExhibit2 = _interopRequireDefault(_ShareExhibit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//  Components
	var Conclusion = function Conclusion(_ref) {
	  var data = _ref.data;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'article',
	      null,
	      _react2.default.createElement(
	        'h1',
	        { className: 'title__page' },
	        'Conclusion'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'section' },
	        _react2.default.createElement(
	          'div',
	          { className: 'section__row section__row__2_up' },
	          _react2.default.createElement(
	            'div',
	            { className: 'section__content' },
	            _react2.default.createElement(
	              'h3',
	              null,
	              'All states can improve their health care performance, including those that topped the Scorecard rankings.'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'On certain health system indicators, states ranked lower overall performed better than the overall leaders. This suggests that even the lower-ranking states have something to teach.'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'section__content' },
	            _react2.default.createElement(
	              'p',
	              null,
	              'If every state achieved the performance of the top-ranked state on each Scorecard indicator, the gains in health care access, quality, efficiency, and outcomes would be dramatic. At current rates of improvement, however, it may take many years or decades for states and the nation to see such progress.'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'section__content section__exhibit section__exhibit__padded section__full' },
	          _react2.default.createElement(
	            'h2',
	            { className: 'title__block' },
	            'National gains if all states achieved top rates* of performance'
	          ),
	          _react2.default.createElement(
	            'figure',
	            null,
	            _react2.default.createElement('img', { src: (0, _gatsbyLink.withPrefix)('/img/exhibits/exhibit-13-web.png'), alt: '' }),
	            _react2.default.createElement(
	              'figcaption',
	              null,
	              _react2.default.createElement(
	                'p',
	                null,
	                '* Performance benchmarks set at the level achieved by the top-performing state with available data for this indicator.'
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                _react2.default.createElement(
	                  'sup',
	                  null,
	                  'a'
	                ),
	                ' Estimate based on working-age population, ages 18\u201364, with employer-sponsored insurance, and Medicare beneficiaries age 65 and older.'
	              )
	            )
	          ),
	          _react2.default.createElement(_ShareExhibit2.default, {
	            exhibit: 'exhibit-13',
	            site: data.site.siteMetadata,
	            social: data.allSocialJson.edges })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'section' },
	        _react2.default.createElement(
	          'div',
	          { className: 'section__row section__row__2_up' },
	          _react2.default.createElement(
	            'div',
	            { className: 'section__content' },
	            _react2.default.createElement(
	              'h3',
	              null,
	              'States have many opportunities to lead and to collaborate with other stakeholders to promote health system improvement.',
	              _react2.default.createElement(
	                'sup',
	                { className: 'note__link' },
	                _react2.default.createElement(
	                  'a',
	                  { href: '#34' },
	                  '34'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'Many states are already doing so by:'
	            ),
	            _react2.default.createElement(
	              'ul',
	              null,
	              _react2.default.createElement(
	                'li',
	                null,
	                'expanding Medicaid eligibility under the Affordable Care Act (ACA)',
	                _react2.default.createElement(
	                  'sup',
	                  { className: 'note__link' },
	                  _react2.default.createElement(
	                    'a',
	                    { href: '#35' },
	                    '35'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'establishing rules to ensure well-functioning insurance markets',
	                _react2.default.createElement(
	                  'sup',
	                  { className: 'note__link' },
	                  _react2.default.createElement(
	                    'a',
	                    { href: '#36' },
	                    '36'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'using \u201Cvalue-based purchasing\u201D in Medicaid and state employee benefits programs in order to promote higher-quality, lower-cost care',
	                _react2.default.createElement(
	                  'sup',
	                  { className: 'note__link' },
	                  _react2.default.createElement(
	                    'a',
	                    { href: '#37' },
	                    '37'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'promoting secure and efficient methods for care providers, health plans, and state programs to share electronic health information for quality improvement',
	                _react2.default.createElement(
	                  'sup',
	                  { className: 'note__link' },
	                  _react2.default.createElement(
	                    'a',
	                    { href: '#38' },
	                    '38'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'supporting sustainable efforts to address the social determinants of health',
	                _react2.default.createElement(
	                  'sup',
	                  { className: 'note__link' },
	                  _react2.default.createElement(
	                    'a',
	                    { href: '#39' },
	                    '39'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                null,
	                'ensuring an adequate primary care workforce, especially in underserved areas',
	                _react2.default.createElement(
	                  'sup',
	                  { className: 'note__link' },
	                  _react2.default.createElement(
	                    'a',
	                    { href: '#40' },
	                    '40'
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'section__content' },
	            _react2.default.createElement(
	              'p',
	              null,
	              'Some states are in better economic shape than others and have more resources to support improvement. But the gains in access to care and narrowing of disparities associated with the ACA\u2019s coverage expansions highlight the role that public programs can play in equalizing opportunity across and within states.',
	              _react2.default.createElement(
	                'sup',
	                { className: 'note__link' },
	                _react2.default.createElement(
	                  'a',
	                  { href: '#41' },
	                  '41'
	                )
	              ),
	              ' (For example, see ',
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/case-study/new-york-moves-to-improve#new-york-improvements' },
	                'New York\u2019s improvements'
	              ),
	              '.)'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'These gains in access to care may be compromised, however, by the repeal of the ACA\u2019s individual mandate penalty and by regulatory changes to state insurance markets currently under way.',
	              _react2.default.createElement(
	                'sup',
	                { className: 'note__link' },
	                _react2.default.createElement(
	                  'a',
	                  { href: '#42' },
	                  '42'
	                )
	              ),
	              ' Although states have tools to strengthen their individual insurance markets, such as reinsurance mechanisms that can help moderate premium increases,',
	              _react2.default.createElement(
	                'sup',
	                { className: 'note__link' },
	                _react2.default.createElement(
	                  'a',
	                  { href: '#43' },
	                  '43'
	                )
	              ),
	              ' there are limits to what the health law can do. Insurance coverage is a necessary but not sufficient condition for improving health care and outcomes. Urgent concerns such as the opioid crisis may call for new initiatives.',
	              _react2.default.createElement(
	                'sup',
	                { className: 'note__link' },
	                _react2.default.createElement(
	                  'a',
	                  { href: '#44' },
	                  '44'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              'With states assuming ever greater responsibility for the future of health policy, it will be more important than ever to continue tracking the performance of the health system throughout the country.'
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(_ThemeNavFooter2.default, { themes: data.allThemesJson.edges }),
	    _react2.default.createElement(
	      'div',
	      { className: 'section section__notes' },
	      _react2.default.createElement(
	        'div',
	        { className: 'section__row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'section__content' },
	          _react2.default.createElement(
	            'ol',
	            { start: '34', style: { counterReset: "item 33" }, className: 'list__notes' },
	            _react2.default.createElement(
	              'li',
	              { id: '34' },
	              'Sharon Silow-Carroll and Greg Moody, ',
	              _react2.default.createElement(
	                'em',
	                null,
	                'Lessons from High- and Low-Performing States for Raising Overall Health System Performance'
	              ),
	              ' (The Commonwealth Fund, May 2011), ',
	              _react2.default.createElement(
	                'a',
	                { href: 'http://www.commonwealthfund.org/publications/issue-briefs/2011/may/high-and-low-performing-states' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'http://www.commonwealthfund.org/publications/issue-briefs/2011/may/high-and-low-performing-states'
	                )
	              ),
	              '.'
	            ),
	            _react2.default.createElement(
	              'li',
	              { id: '35' },
	              'Benjamin D. Sommers et al., \u201CChanges in Utilization and Health Among Low-Income Adults After Medicaid Expansion or Expanded Private Insurance,\u201D ',
	              _react2.default.createElement(
	                'em',
	                null,
	                'JAMA Internal Medicine'
	              ),
	              ', published online Aug. 8, 2016, ',
	              _react2.default.createElement(
	                'a',
	                { href: 'http://www.commonwealthfund.org/publications/in-the-literature/2016/aug/changes-utilization-health-low-income' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'http://www.commonwealthfund.org/publications/in-the-literature/2016/aug/changes-utilization-health-low-income'
	                )
	              ),
	              '; and Benjamin D. Sommers et al., \u201CThree-Year Impacts of the Affordable Care Act: Improved Medical Care and Health Among Low-Income Adults,\u201D ',
	              _react2.default.createElement(
	                'em',
	                null,
	                'Health Affairs Web First'
	              ),
	              ', published online May 17, 2017; ',
	              _react2.default.createElement(
	                'a',
	                { href: 'http://www.commonwealthfund.org/publications/in-the-literature/2017/may/aca-improved-medical-care-and-health' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'http://www.commonwealthfund.org/publications/in-the-literature/2017/may/aca-improved-medical-care-and-health'
	                )
	              ),
	              '.'
	            ),
	            _react2.default.createElement(
	              'li',
	              { id: '36' },
	              'Sabrina Corlette, Kevin Lucia, and Maanasa Kona, \u201CStates Step Up to Protect Consumers in Wake of Cuts to ACA Cost-Sharing Reduction Payments,\u201D ',
	              _react2.default.createElement(
	                'em',
	                null,
	                'To the Point'
	              ),
	              ' (blog), The Commonwealth Fund, Oct. 27, 2017, ',
	              _react2.default.createElement(
	                'a',
	                { href: 'http://www.commonwealthfund.org/publications/blog/2017/oct/states-protect-consumers-in-wake-of-aca-cost-sharing-payment-cuts' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'http://www.commonwealthfund.org/publications/blog/2017/oct/states-protect-consumers-in-wake-of-aca-cost-sharing-payment-cuts'
	                )
	              ),
	              '; Justin Giovannelli and Ashley Williams, \u201CRegulation of Narrow Networks: With Federal Protections in Jeopardy, State Approaches Take on Added Significance,\u201D ',
	              _react2.default.createElement(
	                'em',
	                null,
	                'To the Point'
	              ),
	              ' (blog), The Commonwealth Fund, Jan. 31, 2017, ',
	              _react2.default.createElement(
	                'a',
	                { href: 'http://www.commonwealthfund.org/publications/blog/2017/feb/regulation-of-narrow-networks' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'http://www.commonwealthfund.org/publications/blog/2017/feb/regulation-of-narrow-networks'
	                )
	              ),
	              '.'
	            ),
	            _react2.default.createElement(
	              'li',
	              { id: '37' },
	              'Bailit Health and National Association of Medicaid Directors, ',
	              _react2.default.createElement(
	                'em',
	                null,
	                'The Role of State Medicaid Programs in Improving the Health Care System'
	              ),
	              ' (NAMD, Mar. 22, 2016), ',
	              _react2.default.createElement(
	                'a',
	                { href: 'http://medicaiddirectors.org/wp-content/uploads/2016/03/NAMD_Bailit-Health_Value-Based-Purchasing-in-Medicaid.pdf' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'http://medicaiddirectors.org/wp-content/uploads/2016/03/NAMD_Bailit-Health_Value-Based-Purchasing-in-Medicaid.pdf'
	                )
	              ),
	              '; and Michael Bailit, Megan Burns, and Mary Beth Dyer, ',
	              _react2.default.createElement(
	                'em',
	                null,
	                'Value-Based-Innovation by State Public Employee Health Benefits Programs'
	              ),
	              ' (State Health and Value Strategies, Princeton University Woodrow Wilson School of Public and International Affairs, Nov. 2017), ',
	              _react2.default.createElement(
	                'a',
	                { href: 'https://www.shvs.org/resource/value-based-innovation-by-state-public-employee-health-benefits-programs' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'https://www.shvs.org/resource/value-based-innovation-by-state-public-employee-health-benefits-programs'
	                )
	              ),
	              '.'
	            ),
	            _react2.default.createElement(
	              'li',
	              { id: '38' },
	              'Kate Johnson et al., ',
	              _react2.default.createElement(
	                'em',
	                null,
	                'Getting the Right Information to the Right Health Care Providers at the Right Time: A Road Map for States to Improve Health Information Flow Between Providers'
	              ),
	              ' (National Governors Association Center for Best Practices, Dec. 2016), ',
	              _react2.default.createElement(
	                'a',
	                { href: 'https://www.nga.org/cms/center/publications/health/health-information-flow' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'https://www.nga.org/cms/center/publications/health/health-information-flow'
	                )
	              ),
	              '.'
	            ),
	            _react2.default.createElement(
	              'li',
	              { id: '39' },
	              'Deborah Bachrach, Jocelyn Guyer, and Ariel Levin, ',
	              _react2.default.createElement(
	                'em',
	                null,
	                'Medicaid Coverage of Social Interventions: A Road Map for States'
	              ),
	              ' (Milbank Memorial Fund, July 2016), ',
	              _react2.default.createElement(
	                'a',
	                { href: 'https://www.milbank.org/publications/medicaid-coverage-social-interventions-road-map-states' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'https://www.milbank.org/publications/medicaid-coverage-social-interventions-road-map-states'
	                )
	              ),
	              '.'
	            ),
	            _react2.default.createElement(
	              'li',
	              { id: '40' },
	              'National Conference of State Legislatures, ',
	              _react2.default.createElement(
	                'em',
	                null,
	                'Primary Care Workforce: A Health Care Safety-Net Toolkit for State Legislators'
	              ),
	              ' (NCSL, 2013), ',
	              _react2.default.createElement(
	                'a',
	                { href: 'http://www.ncsl.org/documents/health/PCWorkforceTK13.pdf' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'http://www.ncsl.org/documents/health/PCWorkforceTK13.pdf'
	                )
	              ),
	              '.'
	            ),
	            _react2.default.createElement(
	              'li',
	              { id: '41' },
	              'Michelle M. Doty, Munira Z. Gunja, and Sara R. Collins, \u201CCoverage Gains Among Lower-Income Blacks and Latinos Highlight ACA\u2019s Successes and Areas for Improvement,\u201D ',
	              _react2.default.createElement(
	                'em',
	                null,
	                'To the Point'
	              ),
	              ' (blog), The Commonwealth Fund, Aug. 15, 2017, ',
	              _react2.default.createElement(
	                'a',
	                { href: 'http://www.commonwealthfund.org/publications/blog/2017/aug/coverage-gains-blacks-and-latinos' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'http://www.commonwealthfund.org/publications/blog/2017/aug/coverage-gains-blacks-and-latinos'
	                )
	              ),
	              '; and Susan L. Hayes et al., ',
	              _react2.default.createElement(
	                'em',
	                null,
	                'Reducing Racial and Ethnic Disparities in Access to Care: Has the Affordable Care Act Made a Difference?'
	              ),
	              ' (The Commonwealth Fund, Aug. 2017), ',
	              _react2.default.createElement(
	                'a',
	                { href: 'http://www.commonwealthfund.org/publications/issue-briefs/2017/aug/racial-ethnic-disparities-care' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'http://www.commonwealthfund.org/publications/issue-briefs/2017/aug/racial-ethnic-disparities-care'
	                )
	              ),
	              '.'
	            ),
	            _react2.default.createElement(
	              'li',
	              { id: '42' },
	              'David Blumenthal, \u201CThe ACA at Eight: Resilient But Still at Risk,\u201D ',
	              _react2.default.createElement(
	                'em',
	                null,
	                'To the Point'
	              ),
	              ' (blog), The Commonwealth Fund, Mar. 23, 2018, ',
	              _react2.default.createElement(
	                'a',
	                { href: 'http://www.commonwealthfund.org/publications/blog/2018/mar/aca-at-eight' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'http://www.commonwealthfund.org/publications/blog/2018/mar/aca-at-eight'
	                )
	              ),
	              '.'
	            ),
	            _react2.default.createElement(
	              'li',
	              { id: '43' },
	              'Kevin Lucia et al., ',
	              _react2.default.createElement(
	                'em',
	                null,
	                'State Regulation of Coverage Options Outside of the Affordable Care Act: Limiting the Risk to the Individual Market'
	              ),
	              ' (The Commonwealth Fund, Mar. 2018), ',
	              _react2.default.createElement(
	                'a',
	                { href: 'http://www.commonwealthfund.org/publications/fund-reports/2018/mar/state-regulation-coverage-options-outside-aca' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'http://www.commonwealthfund.org/publications/fund-reports/2018/mar/state-regulation-coverage-options-outside-aca'
	                )
	              ),
	              '; and Michael Ollove, \u201CTo Curb Rising Health Insurance Costs, Some States Try \u2018Reinsurance Pools\u2019,\u201D ',
	              _react2.default.createElement(
	                'em',
	                null,
	                'Stateline'
	              ),
	              ' (blog), Pew Charitable Trusts, Apr. 9, 2018, ',
	              _react2.default.createElement(
	                'a',
	                { href: 'http://www.pewtrusts.org/en/research-and-analysis/blogs/stateline/2018/04/09/to-curb-rising-health-insurance-costs-some-states-try-reinsurance-pools' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'http://www.pewtrusts.org/en/research-and-analysis/blogs/stateline/2018/04/09/to-curb-rising-health-insurance-costs-some-states-try-reinsurance-pools'
	                )
	              ),
	              '.'
	            ),
	            _react2.default.createElement(
	              'li',
	              { id: '44' },
	              'Kelly Murphy et al., ',
	              _react2.default.createElement(
	                'em',
	                null,
	                'Finding Solutions to the Prescription Opioid and Heroin Crisis: A Road Map for States'
	              ),
	              ' (National Governors Association Center for Best Practices, July 2016), ',
	              _react2.default.createElement(
	                'a',
	                { href: 'https://www.nga.org/cms/finding-solutions-to-the-prescription-opioid-and-heroin-crisis-a-road-map-for-states' },
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  'https://www.nga.org/cms/finding-solutions-to-the-prescription-opioid-and-heroin-crisis-a-road-map-for-states'
	                )
	              ),
	              '.'
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = Conclusion;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-conclusion-js-7ef11cfe57e6e83a7f14.js